import { render } from "./SimpleOptionSelector.vue?vue&type=template&id=2a7a9fb0&scoped=true"
import script from "./SimpleOptionSelector.vue?vue&type=script&lang=js"
export * from "./SimpleOptionSelector.vue?vue&type=script&lang=js"

import "./SimpleOptionSelector.vue?vue&type=style&index=0&id=2a7a9fb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a7a9fb0"]])

export default __exports__